// extracted by mini-css-extract-plugin
export var imgNoText = "survey-option-square-no-text-module--img-no-text--u6ueH";
export var noTextIcon = "survey-option-square-no-text-module--no-text-icon--b37nY";
export var noTextInput = "survey-option-square-no-text-module--no-text-input--SRDte";
export var noTextOption = "survey-option-square-no-text-module--no-text-option--DXbz8";
export var noTextWrapper = "survey-option-square-no-text-module--no-text-wrapper---KQUG";